var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_356",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.596L15.6538 13.9423L14.6 12.8885L12.75 14.7385V10.2885H11.25V14.7385L9.4 12.8885L8.34625 13.9423L12 17.596ZM5 7.90375V18.6923C5 18.7821 5.02883 18.8558 5.0865 18.9135C5.14417 18.9712 5.21792 19 5.30775 19H18.6923C18.7821 19 18.8558 18.9712 18.9135 18.9135C18.9712 18.8558 19 18.7821 19 18.6923V7.90375H5ZM5.38475 20.5C4.88592 20.5 4.44708 20.3106 4.06825 19.9318C3.68942 19.5529 3.5 19.1141 3.5 18.6152V7.00575C3.5 6.79175 3.53433 6.58758 3.603 6.39325C3.6715 6.19908 3.77433 6.01992 3.9115 5.85575L5.3155 4.15775C5.4795 3.94358 5.68458 3.78042 5.93075 3.66825C6.17692 3.55608 6.43717 3.5 6.7115 3.5H17.2693C17.5436 3.5 17.8054 3.55608 18.0548 3.66825C18.3041 3.78042 18.5108 3.94358 18.675 4.15775L20.0885 5.875C20.2257 6.03917 20.3285 6.21992 20.397 6.41725C20.4657 6.61475 20.5 6.82058 20.5 7.03475V18.6152C20.5 19.1141 20.3106 19.5529 19.9318 19.9318C19.5529 20.3106 19.1141 20.5 18.6152 20.5H5.38475ZM5.3905 6.404H18.6L17.5095 5.10575C17.4775 5.07375 17.4407 5.04808 17.399 5.02875C17.3573 5.00958 17.3141 5 17.2693 5H6.72125C6.67642 5 6.63308 5.00958 6.59125 5.02875C6.54958 5.04808 6.51275 5.07375 6.48075 5.10575L5.3905 6.404Z",
    fill: "#1D61E7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.018ac905d5efec5ea9edb00f4fa6d5a7.svg";
export { ForwardRef as ReactComponent };